export default "__VITE_ASSET__X2H8pqwr__"